module.exports = __webpack_public_path__ + "img/power-one.e3d0bf40.png";